import { BaseService } from './base';
import { ProductBrand } from '../models/productBrand';

export class ProductBrandService extends BaseService<ProductBrand> {
  override model = ProductBrand;
  override modelName = 'productBrand';
  override modelLabel = 'Product Brand';
}
